<div class="date-filter-container pr-2">
    <!-- Barre supérieure : Navigation et sélecteurs de mode -->
    <div class="date-filter-header">
        <div class="date-nav-section">
            <button class="btn date-nav-btn" (click)="decrementDate()" rippleEffect>
                <i data-feather="chevron-left"></i>
            </button>
            <button class="btn date-nav-btn" (click)="incrementDate()" rippleEffect>
                <i data-feather="chevron-right"></i>
            </button>
            <p class="date-display">{{ selectedPeriod || '' }}</p>
        </div>

        <div class="date-filter-buttons">
            <div class="btn-group" role="group">
                <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('jours')" [class.active]="viewMode==='jours'">
                    <p>Jours</p>
                </button>
                <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('mois')" [class.active]="viewMode==='mois'">
                    <p>Mois</p>
                </button>
                <button type="button" class="btn bouttons" rippleEffect (click)="changeViewMode('annees')" [class.active]="viewMode==='annees'">
                    <p>Année</p>
                </button>

                <button class="btn bouttons" rippleEffect (click)="openFlatpickr(); $event.preventDefault()" style="color: rgba(19, 74, 211, 1);">
                    <i data-feather="calendar" ></i>
                </button>
            </div>
            <input type="text" #datePicker class="flatpickr-input" style="margin-top: 40px;" />
        </div>
    </div>

    <!-- Barre inférieure : Sélecteur de jours horizontal -->
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'jours'">
    <div class="data-list-wrapper">
        <div *ngFor="let day of weekDays"
             (click)="selectDay(day)"
             [class.selected]="day.dateString === selectedDay"
             [class.today]="day.isToday"
             class="day-item">
            {{ day.label }}
        </div>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'mois'">
    <div class="data-list-wrapper">
        <div *ngFor="let month of months; let i=index"
             (click)="selectMonth(i)"
             [class.selected]="i === selectedMonthIndex"
             [class.today]="i === currentMonthIndex"
             class="month-item">
            {{ month }}
        </div>
    </div>
</div>

<div class="data-list mb-0 p-0" *ngIf="viewMode === 'annees'">
    <div class="data-list-wrapper">
        <div *ngFor="let year of years"
             (click)="selectYear(year)"
             [class.selected]="year === selectedYear"
             [class.today]="year === currentYear"
             class="year-item">
            {{ year }}
        </div>
    </div>
</div>
